import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'years',
})
export class YearsPipe implements PipeTransform {
    transform(value: number | string, returnOnlyWord: boolean = false, forceNumber: boolean = false) {
        if (forceNumber) {
            value = Number(value);
        }
        if (value && typeof value === 'string') {
            return value;
        }
        let word = 'let';
        if (typeof value === 'number') {
            if (value === 1) {
                word = 'rok';
            } else if (value >= 2 && value < 5) {
                word = 'roky';
            }
        }
        return returnOnlyWord ? `${word}` : `${value} ${word}`;
    }
}
